/* ============
 * Vuex Actions
 * ============
 */
import authentication from 'features/authentication/authentication.actions';
import * as accountActions from './account';
import * as roundtableActions from 'features/onlineRoundtables/onlineRoundtables.actions';
import * as courseActions from './courses';
import * as gradeActions from './grades';
import liveDiscussionActions from './liveDiscussions';
import * as analytics from 'features/analytics/analytics.actions';
import * as notifications from './notifications';
import * as polls from './polls';
import * as premades from './premades';
import * as invites from './invites';
import * as adminPortal from './adminPortal';

export default {
  ...authentication,
  ...analytics,
  ...accountActions,
  ...roundtableActions,
  ...courseActions,
  ...gradeActions,
  ...liveDiscussionActions,
  ...notifications,
  ...polls,
  ...premades,
  ...invites,
  ...adminPortal,
};



// WEBPACK FOOTER //
// ./src/app/store/actions/index.js